import createSagaMiddleware from "@redux-saga/core";
import { configureStore } from "@reduxjs/toolkit";
import debounce from "debounce";
import { TypedUseSelectorHook } from "react-redux";
import { useSelector as useReduxSelector } from "react-redux/es/hooks/useSelector";
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync';
import { loginActions } from "../../pages/LoginPage/reducer";
import { messageActions } from "../../pages/MessagePage/reducer";
import { planOpActions } from "../../pages/PlanOperationPage/reducer";
import { KEY_STORAGE } from "../varibles/constants";
import rootReducer from "./rootReducer";
import rootSaga from "./rootSaga";

const customState = (state: AppState) => {
    const { login } = state;
    return { login };
}

const saveState = (state: AppState) => {
    try {
        const data = customState(state);
        const serializedState = JSON.stringify(data);
        localStorage.setItem(KEY_STORAGE.STATE, serializedState);
    } catch (error) {
        console.log(error)
    }
};

const loadState = () => {
    try {
        const serializedState = localStorage.getItem(KEY_STORAGE.STATE);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (e) {
        return undefined;
    }
};

const sagaMiddleware = createSagaMiddleware();

const config = {
    whitelist: [
        // login actions
        loginActions.getUserSuccess.type,
        loginActions.logout.type,
        loginActions.updateUserSetting.type,

        // plan actions
        planOpActions.adddRoute.type,
        // CREATE_OP_SUCCESS,
        // DELETE_OPERATIONS_REQUEST,
        // UPDATE_TREATMENT_OPERATION,
        // ADD_EVENT_OPERATION,
        // UPDATE_EVENT_OPERATION,

        // message actions
        messageActions.readMessage.type,
        messageActions.updateMessage.type,
    ],
};

export const store = configureStore({
    reducer: rootReducer,
    preloadedState: loadState(),
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({
            serializableCheck: false,
            thunk: false
        }),
        createStateSyncMiddleware(config),
        sagaMiddleware
    ],
});

export const getStore = () => store.getState()
export const getDispatch = () => store.dispatch

initMessageListener(store);

sagaMiddleware.run(rootSaga);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector

store.subscribe(debounce(() => saveState(store.getState()), 800));